module.exports = __webpack_public_path__ + "static/images/containers/PostbattleScreen/components/FortBattleSeries/images/arrow-attack-long-highlight.67748873.png";


//////////////////
// WEBPACK FOOTER
// ./containers/PostbattleScreen/components/FortBattleSeries/images/arrow-attack-long-highlight.png
// module id = 3214
// module chunks = 11